/**
 * Features Tabs Controller
 *
 * Handles tab switching for the homepage features section.
 * Toggles active state on tabs and corresponding images.
 *
 * Usage:
 *   - Add data-controller="features-tabs" to the container
 *   - Add data-features-tabs-target="tab" to each tab item
 *   - Add data-features-tabs-target="images" to each images container
 *   - Add data-action="click->features-tabs#switch" to clickable tabs
 *   - Add data-features-tabs-index-value="0" (index) to each tab
 */
import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['tab', 'images'];

  /**
   * Switches the active tab and corresponding image.
   *
   * @param {Event} e - Click event from tab element
   */
  switch(e) {
    const newIndex = e.currentTarget.getAttribute('data-features-tabs-index-value');

    // Update tabs: toggle active class
    for (const [index, tab] of this.tabTargets.entries()) {
      if (index == newIndex) {
        tab.classList.add('lastdodo-features__main__tabs__list__item--active');
      } else {
        tab.classList.remove('lastdodo-features__main__tabs__list__item--active');
      }
    }

    // Update images: toggle active class
    for (const [index, images] of this.imagesTargets.entries()) {
      if (index == newIndex) {
        images.classList.add('lastdodo-features__main__mockup__images--active');
      } else {
        images.classList.remove('lastdodo-features__main__mockup__images--active');
      }
    }
  }
}
